import { 
  signInWithEmailAndPassword, 
  signOut,
  onAuthStateChanged 
} from 'firebase/auth';
import { auth } from '../config/firebase';

export const loginDistributor = async (email, password) => {
  try {
    console.log('Attempting login with:', email);
    const result = await signInWithEmailAndPassword(auth, email, password);
    console.log('Login successful:', result.user);
    return result.user;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

export const logoutDistributor = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error('Logout error:', error);
    throw error;
  }
};

export const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(auth, 
      user => {
        unsubscribe();
        resolve(user);
      },
      error => {
        reject(error);
      }
    );
  });
}; 